import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "form-header d-flex align-items-center" }
const _hoisted_4 = { class: "form-section" }
const _hoisted_5 = { style: {"flex":"0 0 30%"} }
const _hoisted_6 = { class: "form-section" }
const _hoisted_7 = { class: "form-section" }
const _hoisted_8 = { class: "toggle" }
const _hoisted_9 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CommonModal"], {
    ref: "createBranchModal",
    "is-full-screen": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _cache[17] || (_cache[17] = _createElementVNode("header", { class: "header" }, [
          _createElementVNode("h1", { class: "title" }, "Cadastrar nova sede")
        ], -1 /* HOISTED */)),
        _createElementVNode("form", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode($setup["AvatarCard"], {
              item: {
            name: $setup.createBranch.getName(),
            image: $setup.createBranch.getImgUrl()
          },
              size: 'large',
              onOnEdit: $setup.avatarEdit
            }, null, 8 /* PROPS */, ["item"]),
            _createVNode($setup["CommonInput"], {
              label: "Nome",
              class: "w-100",
              state: $setup.createBranch.errors.branchNameError ? 'error' : 'default',
              "supporting-text": $setup.createBranch.errors.branchNameError ?? undefined,
              "model-value": $setup.createBranch.branchName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => {$setup.createBranch.branchName = $event; $setup.createBranch.errors.branchNameError = null;}),
              onTapTrailing: _cache[1] || (_cache[1] = ($event: any) => ($setup.createBranch.branchName = ''))
            }, null, 8 /* PROPS */, ["state", "supporting-text", "model-value"])
          ]),
          _createVNode($setup["AddressSelector"], {
            ref: "addressSelector",
            "model-value": $setup.createBranch.address.getCep(),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => {$setup.createBranch.address.setCep($event);}),
            onSelect: _cache[3] || (_cache[3] = ($event: any) => {$setup.stateSelector?.setSelected($event.getState()); $setup.citySelector?.setSelected($event.getState(), $event.getCity()); $setup.createBranch.setAddress($event);}),
            label: "CEP",
            class: "w-30",
            placeholder: "CEP",
            fetchFunction: $setup.createBranch.fetchAddressByCEP
          }, null, 8 /* PROPS */, ["model-value", "fetchFunction"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode($setup["StateSelector"], {
                ref: "stateSelector",
                "state-error": $setup.createBranch.errors.stateError ?? undefined,
                onChange: _cache[4] || (_cache[4] = ($event: any) => {$setup.createBranch.address.setState($event ?? ''); $setup.citySelector?.setState($event ?? ''); $setup.createBranch.errors.stateError = null})
              }, null, 8 /* PROPS */, ["state-error"])
            ]),
            _createVNode($setup["CitySelector"], {
              ref: "citySelector",
              "city-error": $setup.createBranch.errors.cityError ?? undefined,
              onChange: _cache[5] || (_cache[5] = ($event: any) => {$setup.createBranch.address.setCity($event ?? ''); $setup.createBranch.errors.cityError = null})
            }, null, 8 /* PROPS */, ["city-error"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode($setup["CommonInput"], {
              label: "Bairro",
              style: {"flex":"0 0 30%"},
              class: "w-35",
              state: $setup.createBranch.errors.vicinityError ? 'error' : 'default',
              "supporting-text": $setup.createBranch.errors.vicinityError ?? undefined,
              "model-value": $setup.createBranch.address.getVicinity(),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => {$setup.createBranch.address.setVicinity($event); $setup.createBranch.errors.vicinityError = null;}),
              onTapTrailing: _cache[7] || (_cache[7] = ($event: any) => ($setup.createBranch.address.setVicinity('')))
            }, null, 8 /* PROPS */, ["state", "supporting-text", "model-value"]),
            _createVNode($setup["CommonInput"], {
              label: "Endereço",
              class: "w-100",
              state: $setup.createBranch.errors.streetError ? 'error' : 'default',
              "supporting-text": $setup.createBranch.errors.streetError ?? undefined,
              "model-value": $setup.createBranch.address.getStreet(),
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => {$setup.createBranch.address.setStreet($event); $setup.createBranch.errors.streetError = null;}),
              onTapTrailing: _cache[9] || (_cache[9] = ($event: any) => ($setup.createBranch.address.setStreet('')))
            }, null, 8 /* PROPS */, ["state", "supporting-text", "model-value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["CommonInput"], {
              mask: "#####",
              style: {"flex":"0 0 30%"},
              state: $setup.createBranch.errors.streetNumberError ? 'error' : $setup.createBranch.hasNumber ? 'default' : 'disabled',
              "supporting-text": $setup.createBranch.errors.streetNumberError ?? undefined,
              label: "Número",
              class: "w-35",
              "model-value": $setup.createBranch.address.getStreetNumber(),
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => {$setup.createBranch.address.setStreetNumber($event); $setup.createBranch.errors.streetNumberError = null;}),
              onTapTrailing: _cache[11] || (_cache[11] = ($event: any) => ($setup.createBranch.address.setStreetNumber('')))
            }, null, 8 /* PROPS */, ["state", "supporting-text", "model-value"]),
            _createVNode($setup["CommonInput"], {
              label: "Complemento",
              class: "w-100",
              "model-value": $setup.createBranch.address.getComplement(),
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ($setup.createBranch.address.setComplement($event))),
              onTapTrailing: _cache[13] || (_cache[13] = ($event: any) => ($setup.createBranch.address.setComplement('')))
            }, null, 8 /* PROPS */, ["model-value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode($setup["CommonToggle"], {
              label: "Endereço sem número",
              name: "autoGenDefaultBasket",
              value: !$setup.createBranch.hasNumber,
              onChange: _cache[14] || (_cache[14] = (_, value) => { $setup.createBranch.hasNumber = !value; $setup.createBranch.address.setStreetNumber('') })
            }, null, 8 /* PROPS */, ["value"])
          ])
        ]),
        _createElementVNode("footer", _hoisted_9, [
          _createVNode($setup["CommonButton"], {
            type: "outlined",
            "border-radius": "small",
            action: "secondary",
            onClick: _cache[15] || (_cache[15] = () => { $setup.createBranchModal?.close(); $setup.clearAll(); }),
            text: "Cancelar cadastro"
          }),
          _createVNode($setup["CommonButton"], {
            type: "filled",
            "border-radius": "small",
            onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.createNewBranch())),
            text: "Confirmar cadastro",
            action: `${$setup.createBranch.canCreate() ? 'cta' : 'disabled'}`
          }, null, 8 /* PROPS */, ["action"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}